import { application } from '@core/controllers/app';

application.register('dtfs-invoicing--invoices',
  require('./dtfs_invoicing/invoices_controller').default);
